import { atom } from "nanostores";

export const isFiltersOpenStore = atom<boolean>(false);

export const drawerTypeStore = atom<
  "date" | "duration" | "speakers" | "rythmes" | "budget" | "themes" | "destinations" | "startMonths" | null
>(null);
